import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandLess = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z" })
});
export default SvgExpandLess;
